export const COMMAND_PALETTE_NEW_ACTIVITY = 'COMMAND_PALETTE_NEW_ACTIVITY';
export const COMMAND_PALETTE_CLEAR_NEW_ACTIVITY =
  'COMMAND_PALETTE_CLEAR_NEW_ACTIVITY';
